<template>
    <CCardBody style="background-color: #F5F5F5;">
        
        <CRow>
            <CButton
                size="sm"
                class="btn-class mb-1"
                @click="editarInfoCliente">
                Editar Información
            </CButton>
        </CRow>
        <CRow>
            <CCol>
                <div>
                    <span class="font-weight-bold">Habilitado: </span>
                    <CIcon style="color:green" name="cil-check-circle" v-show="informacionCliente.habilitado"/>
                    <CIcon style="color:red" name="cil-x-circle" v-show="!informacionCliente.habilitado" />
                </div>
                <div><span class="font-weight-bold">Rut: </span> {{(informacionCliente.rutCliente != null) ? $utils.formatearRut(informacionCliente.rutCliente) : 'Sin Rut'}}</div>
                
                <div class="infoDetalle"><span class="font-weight-bold">Nombre: </span>
                <span
                    v-show="!editarInfo"
                    :content="informacionCliente.nombreCliente"                                            
                    v-tippy="{ 
                        placement: 'top',
                        arrow: true, 
                        arrowType: 'round', 
                        animation:'fade',
                        theme: 'google',
                        followCursor : true,
                    }">
                    {{ informacionCliente.nombreCliente }}
                </span>
                <span v-show="editarInfo">
                    <CRow>
                        <CCol sm="9">
                            <CInput
                                size
                                v-model="informacionCliente.nombreCliente"
                                type="text"
                                placeholder="Nombre"
                            />
                        </CCol>
                        <CCol sm="3">
                            <CButtonGroup>
                                <CButton color="success" size="sm"
                                    v-tippy="{ 
                                    placement: 'top',
                                    arrow: true, 
                                    arrowType: 'round', 
                                    animation:'fade',
                                    theme: 'google',
                                    followCursor : true,
                                    content:'Aceptar'
                                }"
                                @click="aceptarCambiosCliente">
                                    <CIcon name="cil-check-circle"/><!-- Aceptar-->
                                </CButton>
                                <CButton color="danger" size="sm"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                        content:'Cancelar'
                                    }"
                                    @click="cancelarCambios">
                                    <CIcon name="cil-x-circle"/><!-- Cancelar-->
                                </CButton>
                            </CButtonGroup>
                        </CCol>
                    </CRow>
                </span>
                <span
                    v-show="!editarInfo"
                    @click="editarInfoCliente">
                    <CIcon                                         
                        v-tippy="{ 
                            placement: 'top',
                            arrow: true, 
                            arrowType: 'round', 
                            animation:'fade',
                            theme: 'google',
                            followCursor : true,
                            content:'Editar'
                        }"
                        name="cil-pencil"/>
                    </span>
                </div>
                <div class="infoDetalle">
                    <span class="font-weight-bold">Grupo Vapp: </span> 
                    <span 
                    :content="informacionCliente.grupoVapp"                                            
                    v-tippy="{ 
                        placement: 'top',
                        arrow: true, 
                        arrowType: 'round', 
                        animation:'fade',
                        theme: 'google',
                        followCursor : true,
                    }">{{ informacionCliente.grupoVapp }}</span>
                </div>
                <div class="infoDetalle"><span class="font-weight-bold">Fecha Creacion: </span>{{ $utils.formatearFecha(informacionCliente.fechaCreacionCliente) }}</div>
                <span>
                    <span class="font-weight-bold">Documentos: </span>
                    <span class="text-center mb-3" v-if="informacionB2BMail == null">No hay Cliente asociado en Mail</span>
                    <span class="text-center mb-3" v-else>
                        <span sm="12" md="12" lg="12" v-if="informacionB2BMail.documentoslength<=0"><center>No hay documentos asociados para este cliente</center></span>
                        <span v-else v-bind:key="documento.idDocumento" v-for="(documento, i) in informacionB2BMail.documentos">
                            <span>({{ documento.codigoDocumento }}
                            <a 
                                v-if="documento.idArchivoDrive != null"
                                :href="documento.urlDescarga" 
                                target="_blank" 
                                :style="{'color': (documento.nula?'red':'green')}"
                                style="text-decoration: none;" 
                                content="Descargar Documento"
                                v-tippy="{ 
                                    placement: 'top',
                                    arrow: true, 
                                    arrowType: 'round', 
                                    animation:'fade',
                                    theme: 'google',
                                    followCursor : true,
                                }"
                            >
                                <CIcon :content="$options.freeSet.cilCloudDownload" />                               
                            </a>
                            <a
                                v-else
                                size="sm" variant="ghost"
                                content="Sin Archivo"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                    }"
                                >
                                <CIcon
                                    :content="$options.freeSet.cilMeh"
                                />
                            </a> )
                        </span>
                        </span>
                        <!--
                        <CCol sm="12" md="12" lg="12" v-if="cliente.documentos.length<=0"
                            ><center>No hay documentos asociados para este cliente</center></CCol>
                            <CCol v-else sm="12" md="12" lg="12" 
                            v-bind:key="documento.idDocumento" 
                                v-for="(documento, i) in cliente.documentos">
                                    <DocumentoInfo :documento="documento" />
                            </CCol>
                        <span class="font-weight-bold">N° Documento: </span> {{ documento.codigoDocumento }}
                        <span>(
                            <a 
                                v-if="documento.hayDocumento"
                                :href="documento.urlDocumento" 
                                target="_blank" 
                                style="text-decoration: none; color:#0b7689;" 
                                content="Descargar Documento"
                                v-tippy="{ 
                                    placement: 'top',
                                    arrow: true, 
                                    arrowType: 'round', 
                                    animation:'fade',
                                    theme: 'google',
                                    followCursor : true,
                                }"
                            >
                                <CIcon :content="$options.freeSet.cilCloudDownload" />                               
                            </a>
                            <a
                                v-else
                                size="sm" variant="ghost"
                                content="Sin Archivo"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                    }"
                                >
                                <CIcon
                                    :content="$options.freeSet.cilMeh"
                                />
                            </a> )
                        </span>-->
                    </span>
                </span>
            </CCol>
            <CCol>
                <div><span class="font-weight-bold">Usuarios Hab.: </span> {{ informacionCliente.infoUsuarios.habilitados }}</div>
                <div><span class="font-weight-bold">Usuarios deshab.: </span> {{ informacionCliente.infoUsuarios.deshabilitados }}</div>
                                
            </CCol>
            <CCol>
                <div>
                    <span class="font-weight-bold">Apps: </span> 
                        <span
                            content="Asignadas / Total"                                            
                            v-tippy="{ 
                                placement: 'top',
                                arrow: true, 
                                arrowType: 'round', 
                                animation:'fade',
                                theme: 'google',
                                followCursor : true,
                            }">
                        {{ informacionCliente.infoApps.asignadas }}/{{ informacionCliente.infoApps.totalApps }}
                    </span>
                </div>
            </CCol>
        </CRow>
        {{ informacionCliente }}
        {{informacionB2BMail}}
    </CCardBody>
</template>


<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";

    import Multiselect from "vue-multiselect";

    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    import { freeSet } from "@coreui/icons";

    //import moment from 'moment'
    import { format, formatDistance, formatRelative, isThisISOWeek, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    window.locale = "es";

    

    //import DatePicker from 'vue2-datepicker';
    //import 'vue2-datepicker/index.css';

    import Pagination from 'vue-pagination-2';

    export default {
        name: "InfoCliente",
        freeSet,
        props: {
            informacionCliente: Object,
            informacionB2BMail: Object,
        },
        components: {
            Multiselect,
            Modal: VueModal,
            Pagination,
        },
        data() {
            return {

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
                
                editarInfo: false,
            };
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {
            editarInfoCliente: function(){
                this.editarInfo = !this.editarInfo
                if(this.editarInfo)
                    this.informacionCliente["respaldo"] = {"nombreCliente": this.informacionCliente.nombreCliente}

            },
            aceptarCambiosCliente: function(){
                this.editarInfo = false
            },
            cancelarCambios: function(){
                this.informacionCliente.nombreCliente = this.informacionCliente.respaldo.nombreCliente
                delete this.informacionCliente.respaldo;
                this.editarInfo = false
            }


        },
    };
</script>

<style>

.cardHabil{
    border-color: green;
}
.cardDeshab{
    border-color: red;
}

</style>